export class FilterExtensionsState {
  fuzzySearch: string;

}

export const initalGridFilterExtensionsState: FilterExtensionsState = {
fuzzySearch: null,
};
